import React, { useContext, useEffect, useState } from 'react';
import { regex } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { getValidateNo, getOtp, getAppStatus, saveUserLogin } from '../../../Services/action.js';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ServerMaintenance from '../ServerMaintenance/ServerMaintenance.js';
import { checkForUndefined } from "../../../utils/util";
import { DataContext } from '../../../Components/DataContext.js';


const Registrationpage = () => {
  const { data, setData } = useContext(DataContext);
  const newData = { ...data }
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [resultMobileNumber, setResultMobileNumber] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);
  const [modal, setModal] = useState('');
  const [allow, setAllow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [appStatus, setAppStatus] = useState(true);
  const [validCoupondCode, setValidCouponCode] = useState(false);

  const init = {
    "token": null,
    "tokenData": null,
    "mobileNumber": null,
    "couponCode": null,
    "userType": null,
    "eventId": null,
    "registration": null,
    "couponShow": null,
    "couponCheck": null,
    "couponCheckCode": null,
    "couponCheckMsg": null,
    "transactionStatus": null,
    "scanVal": null,
    "userDetailsBankMsg": null,
    "userDetailsUpiMsg": null
  }




  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);
    }
    else if (type === 2) {
      setIsModalError(false);
    }
    else if (type === 3) {
      setIsModalWarning(false);
      if (allow) {
        setLoader(true);
        getOtp(mobileNumber)
          .then((data) => {
            setAllow(false);
            newData.mobileNumber = mobileNumber;
            setData(newData);
            saveUserLogin({ mobileNo: mobileNumber, sessionId: "", browserDetails: navigator.platform + '##' + navigator.language }).then(data => {
              newData.eventId = data.data.eventId;
              setData(newData);
              getOtp(mobileNumber)
                .then((data) => {
                  setLoader(false);
                  newData.mobileNumber = mobileNumber;
                  setData(newData);
                  navigate('/otp');
                })
                .catch((error) => {
                  setLoader(false);
                });
            })
              .catch(error => {
                setLoader(false);
              });
          })
          .catch((error) => {
            setLoader(false);

          });
        //  })
        // .catch(error => {
        //   setLoader(false);
        // });
      }
    }
  }
  const onSubmit = () => {
    setLoader(true);
    getValidateNo(mobileNumber)
      .then((data) => {
        if (data.status.status === 'Y' && data.statusMsg.code === 0) {

          newData.userType = data.data.userType;
          setData(newData);
          saveUserLogin({ mobileNo: mobileNumber, sessionId: "", browserDetails: navigator.platform + '##' + navigator.language }).then(data => {
            newData.eventId = data.data.eventId;
            setData(newData);
            getOtp(mobileNumber)
              .then((data) => {
                setLoader(false);
                newData.mobileNumber = mobileNumber;
                setData(newData);
                navigate('/otp');
              })
              .catch((error) => {
                setLoader(false);
              });
          })
            .catch(error => {
              setLoader(false);
            });
        } else if (data.status.status === 'N' && data.statusMsg.code === 1) {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalWarning(true)
        }
        else if (data.status.status === 'N' && data.statusMsg.code === -1) {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalError(true)
        } else if (data.status.status === 'Y' && data.statusMsg.code === 2) {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
          setAllow(true);

        }
      })
      .catch((error) => {
        setLoader(false);

      });

  };
  const getStatus = () => {


    setLoader(true);
    getAppStatus()
      .then((data) => {
        if (data.statusMsg.code === 0) {
          setLoader(false);


          setData(init);

          if (!checkForUndefined(window.location.pathname.replace(/\//g, ''))) {
            newData.couponCode = window.location.pathname.replace(/\//g, '');
            setData(newData);
            let couponCodePattern = regex.couponCodeRegex;
            setValidCouponCode(couponCodePattern.test(window.location.pathname.replace(/\//g, '')));
          }
          else {
            setValidCouponCode(false);
          }
        } else {
          setLoader(false);
          setAppStatus(false);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  }


  useEffect(() => {
    getStatus();

  }, []);
  const handleChangeMobileNumber = (event) => {
    setMobileNumber(event.target.value.replace(/\D/g, ''));
    let pattern = regex.phoneRegex;
    let resMobileNumber = pattern.test(event.target.value.replace(/\D/g, ''));
    setResultMobileNumber(resMobileNumber);
    if (!resMobileNumber) {
      setMobileNumberError("Please enter valid mobile number")

    }
  }
  return (

    <>
      {appStatus ?
        <>
          <div className='content-wrapper responsive-wrapper mb-4'>
            <div className='row'>
              <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
                <div className='DarkPanel'>

                  {validCoupondCode && (
                    <div className='col-12'>
                      <h5>Thank you for purchasing Genuine JCB Lubricant</h5>
                    </div>
                  )}
                  {validCoupondCode && (
                    <div className='col-12'>
                      <p className='mb-0'>
                        Please provide your mobile number for Coupon Redemption
                      </p>
                    </div>
                  )}
                  {!validCoupondCode && (
                    <div className='col-12'>
                      <p className='mb-0 red-text'>
                        Please buy a Genuine JCB Superior Product and scan QR to avail the rewards!!!
                      </p>
                    </div>
                  )}
                </div>
                {validCoupondCode && (

                  <section className='FormPanel pt-4'>
                    <div className='row'>
                      <div className='col-lg-12 col-md-12 col-sm-12 mb-3'>
                        <input
                          id='mobileNumber'
                          name='mobileNumber'
                          type='text'
                          className='form-control'
                          placeholder='Please enter mobile number'
                          maxLength={10}
                          autoComplete='off'
                          aria-autocomplete='none'
                          value={mobileNumber}
                          inputMode="numeric"
                          onChange={(event) => handleChangeMobileNumber(event)}
                        />
                        {!resultMobileNumber
                          ? (
                            <div className='error text-danger text-start'>
                              {mobileNumberError}
                            </div>
                          ) : null}
                      </div>
                    </div>
                    <div className='row mb-4'>
                      <div className='col-lg-12 col-md-12 col-sm-12'>
                        <button
                          type='button'
                          className='btn btn-primary'
                          disabled={!resultMobileNumber}
                          onClick={onSubmit}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                   
                  </section>
                )}

                <div className='col-12 my-2'>
                  <img
                    src={require('../../../Assets/Images/jcb-oil.png')}
                    className=''
                    alt='oil'
                  />
                </div>
              </div>
            </div>
          </div>
          <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
            centered show={isModalSuccess} onHide={() => handleClose(1)} >
            <Modal.Body>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="text-center">
                    <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
                  </div>
                  <p>
                    {modal}
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className="" onClick={() => handleClose(1)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
            centered show={isModalError} onHide={() => handleClose(2)}>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="text-center">
                    <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
                  </div>
                  <p>
                    {modal}
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className="" onClick={() => handleClose(2)}>
                Ok
              </Button>
            </Modal.Footer>
          </Modal >
          <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
            centered show={isModalWarning} onHide={() => handleClose(3)}>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="text-center">
                    <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
                  </div>
                  <p>
                    {modal}
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className="" onClick={() => handleClose(3)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        </>
        :
        <>
          <ServerMaintenance />
        </>
      }
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}


    </>
  );
};

export default Registrationpage;
